export default __webpack_public_path__ + "static/media/mediamath-logo.0f5ffefd.svg";